<template>
  <tr @click="goToPage()">
    <td class="text-no-wrap">
      {{ props.item.code }}
    </td>
    <td class="text-xs-left">
      <a
        href=""
        @click.prevent="goToPage()">{{ props.item.name }}</a>
    </td>
    <td>
      <v-chip
        small
        color="orange"
      >
        {{ props.item.type | beautify }}
      </v-chip>
    </td>
    <td class="text-no-wrap">{{ props.item.created_at | timezone }}</td>
    <td class="text-no-wrap">{{ props.item.updated_at | timezone }}</td>
  </tr>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('cms/components')

export default {
  name: 'ComponentDataTableRow',

  filters: {
    beautify: function (val) {
      return val.replace('_', ' ').toUpperCase()
    }
  },

  props: {
    props: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['templateCode'])
  },

  methods: {
    goToPage () {
      this.$router.push({ name: 'single-component', params: { id: this.props.item.id }, query: { code: this.templateCode } })
    }
  }
}
</script>
